function analyticsApiFactory(storefrontApiClient, hbusApiClient, webtrekkApiClient, googleAnalyticsClient) {
  const analyticsApi = {
    sendDavinciEvent({eventName, eventData}) {
      return hbusApiClient.sendEventRequest(
        eventName,
        eventData,
      );
    },

    sendMultiDavinciEvent({eventArray}) {
      return hbusApiClient.sendMultiEventRequest(
        eventArray
      );
    },

    sendWebtrekkEvent(params) {
      return webtrekkApiClient.sendEventRequest(
        params
      );
    },

    sendGaEvent(params) {
      return googleAnalyticsClient.sendEventRequest(
        params
      );
    },
  };

  return analyticsApi;
}

export default analyticsApiFactory;
